import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

import { colors, distances, transaction_status } from '../../styles/constants';
import { Transaction } from '../../types/checkout';
import { getCurrentEvent } from '../transactionHelpers';


interface TransactionStatusProps {
    transaction: Transaction;
}

const TransactionStatus = ({ transaction }: TransactionStatusProps) => {
    const { t } = useTranslation();
    const status = transaction.status || getCurrentEvent(transaction).transaction_status;
    const statusColors = transaction_status[status || ''] || transaction_status.UNKNOWN;
    if (!status) {
        return null;
    }
    // @ts-ignore
    const statusString = t(`payments.transaction_statuses.${status}`, { defaultValue: status }) as string;
    return <BaseStatus
        title={statusString}
        border={statusColors.border}
        background={statusColors.background}
        text={statusColors.text}
    >
        <span>{statusString}</span>
    </BaseStatus>;
};

interface StatusProps {
    border: string;
    background: string;
    text: string;
}
const BaseStatus = styled.span<StatusProps>`
    font-weight: 600;
    line-height: normal;
    padding: 2px 8px;
    border-radius: 16px;
    display: inline-block;
    border: 1px solid ${props => props.border};
    background: ${props => props.background};
    color: ${props => props.text};
    margin-right: 2px;
    position: relative;
    overflow: hidden;
    max-width: 100%;
    margin-bottom: -6px;

    &> span {
        display: block;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
`;



export default TransactionStatus;
